/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as VerifyEmailRouteImport } from './routes/verify-email'
import { Route as SystemAdminRouteImport } from './routes/system-admin'
import { Route as PendingApprovalRouteImport } from './routes/pending-approval'
import { Route as KbRouteImport } from './routes/kb'
import { Route as AwaitingApprovalRouteImport } from './routes/awaiting-approval'
import { Route as AccountSuspendedRouteImport } from './routes/account-suspended'
import { Route as OrgSetupRouteImport } from './routes/_org-setup'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as AdminRouteImport } from './routes/_admin'
import { Route as R403RouteImport } from './routes/403'
import { Route as SystemAdminIndexRouteImport } from './routes/system-admin/index'
import { Route as AdminIndexRouteImport } from './routes/_admin/index'
import { Route as SystemAdminUsersRouteImport } from './routes/system-admin/users'
import { Route as SystemAdminSettingsRouteImport } from './routes/system-admin/settings'
import { Route as SystemAdminOrgsRouteImport } from './routes/system-admin/orgs'
import { Route as SystemAdminAuditRouteImport } from './routes/system-admin/audit'
import { Route as SystemAdminAdminsRouteImport } from './routes/system-admin/admins'
import { Route as OrgSetupSelectOrgRouteImport } from './routes/_org-setup/select-org'
import { Route as AuthSignupRouteImport } from './routes/_auth/signup'
import { Route as AuthSigninRouteImport } from './routes/_auth/signin'
import { Route as AuthResetPasswordRouteImport } from './routes/_auth/reset-password'
import { Route as AuthInviteRouteImport } from './routes/_auth/invite'
import { Route as AuthForgotPasswordRouteImport } from './routes/_auth/forgot-password'
import { Route as AdminUsageLogsRouteImport } from './routes/_admin/usage-logs'
import { Route as AdminTrashRouteImport } from './routes/_admin/trash'
import { Route as AdminTagsRouteImport } from './routes/_admin/tags'
import { Route as AdminSettingsRouteImport } from './routes/_admin/settings'
import { Route as AdminSearchRouteImport } from './routes/_admin/search'
import { Route as AdminQueryLogsRouteImport } from './routes/_admin/query-logs'
import { Route as AdminPromptUseCaseTypesRouteImport } from './routes/_admin/prompt-use-case-types'
import { Route as AdminPromptEngineRouteImport } from './routes/_admin/prompt-engine'
import { Route as AdminOrganizationsRouteImport } from './routes/_admin/organizations'
import { Route as AdminMyApiKeysRouteImport } from './routes/_admin/my-api-keys'
import { Route as AdminMediaAdminSettingsRouteImport } from './routes/_admin/media-admin-settings'
import { Route as AdminLlmRouteImport } from './routes/_admin/llm'
import { Route as AdminKnowledgesRouteImport } from './routes/_admin/knowledges'
import { Route as AdminKgGraphRouteImport } from './routes/_admin/kg-graph'
import { Route as AdminConnectorsRouteImport } from './routes/_admin/connectors'
import { Route as AdminConnectorTypesRouteImport } from './routes/_admin/connector-types'
import { Route as AdminCategoriesRouteImport } from './routes/_admin/categories'
import { Route as AdminAccountRouteImport } from './routes/_admin/account'
import { Route as SystemAdminOrgsIndexRouteImport } from './routes/system-admin/orgs.index'
import { Route as AdminWorkflowsIndexRouteImport } from './routes/_admin/workflows/index'
import { Route as AdminSettingsIndexRouteImport } from './routes/_admin/settings/index'
import { Route as AdminPromptTemplatesIndexRouteImport } from './routes/_admin/prompt-templates.index'
import { Route as AdminPromptEngineIndexRouteImport } from './routes/_admin/prompt-engine.index'
import { Route as AdminMediaIndexRouteImport } from './routes/_admin/media.index'
import { Route as AdminKnowledgesIndexRouteImport } from './routes/_admin/knowledges.index'
import { Route as AdminConnectorsIndexRouteImport } from './routes/_admin/connectors.index'
import { Route as AdminCheckpointsIndexRouteImport } from './routes/_admin/checkpoints/index'
import { Route as SystemAdminOrgsOrgIdRouteImport } from './routes/system-admin/orgs.$orgId'
import { Route as KbShareTokenRouteImport } from './routes/kb.share.$token'
import { Route as KbOrgSlugSlugRouteImport } from './routes/kb.$orgSlug.$slug'
import { Route as AdminWorkflowsCatalogRouteImport } from './routes/_admin/workflows/catalog'
import { Route as AdminWorkflowsIdRouteImport } from './routes/_admin/workflows/$id'
import { Route as AdminUsageLogsCallIdRouteImport } from './routes/_admin/usage-logs.$callId'
import { Route as AdminSettingsPermissionsRouteImport } from './routes/_admin/settings/permissions'
import { Route as AdminSettingsNotificationsRouteImport } from './routes/_admin/settings/notifications'
import { Route as AdminSettingsMembersRouteImport } from './routes/_admin/settings/members'
import { Route as AdminSettingsMediaRouteImport } from './routes/_admin/settings/media'
import { Route as AdminSettingsLlmCostRouteImport } from './routes/_admin/settings/llm-cost'
import { Route as AdminSettingsInfoRouteImport } from './routes/_admin/settings/info'
import { Route as AdminSettingsGeneralRouteImport } from './routes/_admin/settings/general'
import { Route as AdminSettingsDepartmentsRouteImport } from './routes/_admin/settings/departments'
import { Route as AdminSettingsAuditRouteImport } from './routes/_admin/settings/audit'
import { Route as AdminSettingsAiDataGovernanceRouteImport } from './routes/_admin/settings/ai-data-governance'
import { Route as AdminSettingsAdvancedRouteImport } from './routes/_admin/settings/advanced'
import { Route as AdminSettingsAccessGroupsRouteImport } from './routes/_admin/settings/access-groups'
import { Route as AdminPromptTemplatesNewRouteImport } from './routes/_admin/prompt-templates.new'
import { Route as AdminPromptTemplatesIdRouteImport } from './routes/_admin/prompt-templates.$id'
import { Route as AdminPromptEngineUseCasesRouteImport } from './routes/_admin/prompt-engine.use-cases'
import { Route as AdminMediaUploadRouteImport } from './routes/_admin/media.upload'
import { Route as AdminMediaAssetIdRouteImport } from './routes/_admin/media.$assetId'
import { Route as AdminKnowledgesTagsRouteImport } from './routes/_admin/knowledges.tags'
import { Route as AdminKnowledgesCategoriesRouteImport } from './routes/_admin/knowledges.categories'
import { Route as AdminKnowledgesKnowledgeIdRouteImport } from './routes/_admin/knowledges.$knowledgeId'
import { Route as AdminFeatureDisabledCodeRouteImport } from './routes/_admin/feature-disabled.$code'
import { Route as AdminConnectorsTypesRouteImport } from './routes/_admin/connectors.types'
import { Route as AdminCheckpointsIdRouteImport } from './routes/_admin/checkpoints/$id'
import { Route as AdminPromptEngineTemplatesIndexRouteImport } from './routes/_admin/prompt-engine.templates.index'
import { Route as AdminPromptEngineTemplatesNewRouteImport } from './routes/_admin/prompt-engine.templates.new'
import { Route as AdminPromptEngineTemplatesIdRouteImport } from './routes/_admin/prompt-engine.templates.$id'
import { Route as AdminKnowledgesKnowledgeIdRowFactsRouteImport } from './routes/_admin/knowledges.$knowledgeId.row-facts'
import { Route as AdminWorkflowsIdRunsRunIdRouteImport } from './routes/_admin/workflows/$id.runs.$runId'
import { Route as AdminSettingsUsersUserIdEffectivePermissionsRouteImport } from './routes/_admin/settings/users/$userId.effective-permissions'

const VerifyEmailRoute = VerifyEmailRouteImport.update({
  id: '/verify-email',
  path: '/verify-email',
  getParentRoute: () => rootRouteImport,
} as any)
const SystemAdminRoute = SystemAdminRouteImport.update({
  id: '/system-admin',
  path: '/system-admin',
  getParentRoute: () => rootRouteImport,
} as any)
const PendingApprovalRoute = PendingApprovalRouteImport.update({
  id: '/pending-approval',
  path: '/pending-approval',
  getParentRoute: () => rootRouteImport,
} as any)
const KbRoute = KbRouteImport.update({
  id: '/kb',
  path: '/kb',
  getParentRoute: () => rootRouteImport,
} as any)
const AwaitingApprovalRoute = AwaitingApprovalRouteImport.update({
  id: '/awaiting-approval',
  path: '/awaiting-approval',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountSuspendedRoute = AccountSuspendedRouteImport.update({
  id: '/account-suspended',
  path: '/account-suspended',
  getParentRoute: () => rootRouteImport,
} as any)
const OrgSetupRoute = OrgSetupRouteImport.update({
  id: '/_org-setup',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/_admin',
  getParentRoute: () => rootRouteImport,
} as any)
const R403Route = R403RouteImport.update({
  id: '/403',
  path: '/403',
  getParentRoute: () => rootRouteImport,
} as any)
const SystemAdminIndexRoute = SystemAdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SystemAdminRoute,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRoute,
} as any)
const SystemAdminUsersRoute = SystemAdminUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => SystemAdminRoute,
} as any)
const SystemAdminSettingsRoute = SystemAdminSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => SystemAdminRoute,
} as any)
const SystemAdminOrgsRoute = SystemAdminOrgsRouteImport.update({
  id: '/orgs',
  path: '/orgs',
  getParentRoute: () => SystemAdminRoute,
} as any)
const SystemAdminAuditRoute = SystemAdminAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => SystemAdminRoute,
} as any)
const SystemAdminAdminsRoute = SystemAdminAdminsRouteImport.update({
  id: '/admins',
  path: '/admins',
  getParentRoute: () => SystemAdminRoute,
} as any)
const OrgSetupSelectOrgRoute = OrgSetupSelectOrgRouteImport.update({
  id: '/select-org',
  path: '/select-org',
  getParentRoute: () => OrgSetupRoute,
} as any)
const AuthSignupRoute = AuthSignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSigninRoute = AuthSigninRouteImport.update({
  id: '/signin',
  path: '/signin',
  getParentRoute: () => AuthRoute,
} as any)
const AuthResetPasswordRoute = AuthResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => AuthRoute,
} as any)
const AuthInviteRoute = AuthInviteRouteImport.update({
  id: '/invite',
  path: '/invite',
  getParentRoute: () => AuthRoute,
} as any)
const AuthForgotPasswordRoute = AuthForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => AuthRoute,
} as any)
const AdminUsageLogsRoute = AdminUsageLogsRouteImport.update({
  id: '/usage-logs',
  path: '/usage-logs',
  getParentRoute: () => AdminRoute,
} as any)
const AdminTrashRoute = AdminTrashRouteImport.update({
  id: '/trash',
  path: '/trash',
  getParentRoute: () => AdminRoute,
} as any)
const AdminTagsRoute = AdminTagsRouteImport.update({
  id: '/tags',
  path: '/tags',
  getParentRoute: () => AdminRoute,
} as any)
const AdminSettingsRoute = AdminSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AdminRoute,
} as any)
const AdminSearchRoute = AdminSearchRouteImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => AdminRoute,
} as any)
const AdminQueryLogsRoute = AdminQueryLogsRouteImport.update({
  id: '/query-logs',
  path: '/query-logs',
  getParentRoute: () => AdminRoute,
} as any)
const AdminPromptUseCaseTypesRoute = AdminPromptUseCaseTypesRouteImport.update({
  id: '/prompt-use-case-types',
  path: '/prompt-use-case-types',
  getParentRoute: () => AdminRoute,
} as any)
const AdminPromptEngineRoute = AdminPromptEngineRouteImport.update({
  id: '/prompt-engine',
  path: '/prompt-engine',
  getParentRoute: () => AdminRoute,
} as any)
const AdminOrganizationsRoute = AdminOrganizationsRouteImport.update({
  id: '/organizations',
  path: '/organizations',
  getParentRoute: () => AdminRoute,
} as any)
const AdminMyApiKeysRoute = AdminMyApiKeysRouteImport.update({
  id: '/my-api-keys',
  path: '/my-api-keys',
  getParentRoute: () => AdminRoute,
} as any)
const AdminMediaAdminSettingsRoute = AdminMediaAdminSettingsRouteImport.update({
  id: '/media-admin-settings',
  path: '/media-admin-settings',
  getParentRoute: () => AdminRoute,
} as any)
const AdminLlmRoute = AdminLlmRouteImport.update({
  id: '/llm',
  path: '/llm',
  getParentRoute: () => AdminRoute,
} as any)
const AdminKnowledgesRoute = AdminKnowledgesRouteImport.update({
  id: '/knowledges',
  path: '/knowledges',
  getParentRoute: () => AdminRoute,
} as any)
const AdminKgGraphRoute = AdminKgGraphRouteImport.update({
  id: '/kg-graph',
  path: '/kg-graph',
  getParentRoute: () => AdminRoute,
} as any)
const AdminConnectorsRoute = AdminConnectorsRouteImport.update({
  id: '/connectors',
  path: '/connectors',
  getParentRoute: () => AdminRoute,
} as any)
const AdminConnectorTypesRoute = AdminConnectorTypesRouteImport.update({
  id: '/connector-types',
  path: '/connector-types',
  getParentRoute: () => AdminRoute,
} as any)
const AdminCategoriesRoute = AdminCategoriesRouteImport.update({
  id: '/categories',
  path: '/categories',
  getParentRoute: () => AdminRoute,
} as any)
const AdminAccountRoute = AdminAccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => AdminRoute,
} as any)
const SystemAdminOrgsIndexRoute = SystemAdminOrgsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SystemAdminOrgsRoute,
} as any)
const AdminWorkflowsIndexRoute = AdminWorkflowsIndexRouteImport.update({
  id: '/workflows/',
  path: '/workflows/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminSettingsIndexRoute = AdminSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminSettingsRoute,
} as any)
const AdminPromptTemplatesIndexRoute =
  AdminPromptTemplatesIndexRouteImport.update({
    id: '/prompt-templates/',
    path: '/prompt-templates/',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminPromptEngineIndexRoute = AdminPromptEngineIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminPromptEngineRoute,
} as any)
const AdminMediaIndexRoute = AdminMediaIndexRouteImport.update({
  id: '/media/',
  path: '/media/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminKnowledgesIndexRoute = AdminKnowledgesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminKnowledgesRoute,
} as any)
const AdminConnectorsIndexRoute = AdminConnectorsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminConnectorsRoute,
} as any)
const AdminCheckpointsIndexRoute = AdminCheckpointsIndexRouteImport.update({
  id: '/checkpoints/',
  path: '/checkpoints/',
  getParentRoute: () => AdminRoute,
} as any)
const SystemAdminOrgsOrgIdRoute = SystemAdminOrgsOrgIdRouteImport.update({
  id: '/$orgId',
  path: '/$orgId',
  getParentRoute: () => SystemAdminOrgsRoute,
} as any)
const KbShareTokenRoute = KbShareTokenRouteImport.update({
  id: '/share/$token',
  path: '/share/$token',
  getParentRoute: () => KbRoute,
} as any)
const KbOrgSlugSlugRoute = KbOrgSlugSlugRouteImport.update({
  id: '/$orgSlug/$slug',
  path: '/$orgSlug/$slug',
  getParentRoute: () => KbRoute,
} as any)
const AdminWorkflowsCatalogRoute = AdminWorkflowsCatalogRouteImport.update({
  id: '/workflows/catalog',
  path: '/workflows/catalog',
  getParentRoute: () => AdminRoute,
} as any)
const AdminWorkflowsIdRoute = AdminWorkflowsIdRouteImport.update({
  id: '/workflows/$id',
  path: '/workflows/$id',
  getParentRoute: () => AdminRoute,
} as any)
const AdminUsageLogsCallIdRoute = AdminUsageLogsCallIdRouteImport.update({
  id: '/$callId',
  path: '/$callId',
  getParentRoute: () => AdminUsageLogsRoute,
} as any)
const AdminSettingsPermissionsRoute =
  AdminSettingsPermissionsRouteImport.update({
    id: '/permissions',
    path: '/permissions',
    getParentRoute: () => AdminSettingsRoute,
  } as any)
const AdminSettingsNotificationsRoute =
  AdminSettingsNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => AdminSettingsRoute,
  } as any)
const AdminSettingsMembersRoute = AdminSettingsMembersRouteImport.update({
  id: '/members',
  path: '/members',
  getParentRoute: () => AdminSettingsRoute,
} as any)
const AdminSettingsMediaRoute = AdminSettingsMediaRouteImport.update({
  id: '/media',
  path: '/media',
  getParentRoute: () => AdminSettingsRoute,
} as any)
const AdminSettingsLlmCostRoute = AdminSettingsLlmCostRouteImport.update({
  id: '/llm-cost',
  path: '/llm-cost',
  getParentRoute: () => AdminSettingsRoute,
} as any)
const AdminSettingsInfoRoute = AdminSettingsInfoRouteImport.update({
  id: '/info',
  path: '/info',
  getParentRoute: () => AdminSettingsRoute,
} as any)
const AdminSettingsGeneralRoute = AdminSettingsGeneralRouteImport.update({
  id: '/general',
  path: '/general',
  getParentRoute: () => AdminSettingsRoute,
} as any)
const AdminSettingsDepartmentsRoute =
  AdminSettingsDepartmentsRouteImport.update({
    id: '/departments',
    path: '/departments',
    getParentRoute: () => AdminSettingsRoute,
  } as any)
const AdminSettingsAuditRoute = AdminSettingsAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => AdminSettingsRoute,
} as any)
const AdminSettingsAiDataGovernanceRoute =
  AdminSettingsAiDataGovernanceRouteImport.update({
    id: '/ai-data-governance',
    path: '/ai-data-governance',
    getParentRoute: () => AdminSettingsRoute,
  } as any)
const AdminSettingsAdvancedRoute = AdminSettingsAdvancedRouteImport.update({
  id: '/advanced',
  path: '/advanced',
  getParentRoute: () => AdminSettingsRoute,
} as any)
const AdminSettingsAccessGroupsRoute =
  AdminSettingsAccessGroupsRouteImport.update({
    id: '/access-groups',
    path: '/access-groups',
    getParentRoute: () => AdminSettingsRoute,
  } as any)
const AdminPromptTemplatesNewRoute = AdminPromptTemplatesNewRouteImport.update({
  id: '/prompt-templates/new',
  path: '/prompt-templates/new',
  getParentRoute: () => AdminRoute,
} as any)
const AdminPromptTemplatesIdRoute = AdminPromptTemplatesIdRouteImport.update({
  id: '/prompt-templates/$id',
  path: '/prompt-templates/$id',
  getParentRoute: () => AdminRoute,
} as any)
const AdminPromptEngineUseCasesRoute =
  AdminPromptEngineUseCasesRouteImport.update({
    id: '/use-cases',
    path: '/use-cases',
    getParentRoute: () => AdminPromptEngineRoute,
  } as any)
const AdminMediaUploadRoute = AdminMediaUploadRouteImport.update({
  id: '/media/upload',
  path: '/media/upload',
  getParentRoute: () => AdminRoute,
} as any)
const AdminMediaAssetIdRoute = AdminMediaAssetIdRouteImport.update({
  id: '/media/$assetId',
  path: '/media/$assetId',
  getParentRoute: () => AdminRoute,
} as any)
const AdminKnowledgesTagsRoute = AdminKnowledgesTagsRouteImport.update({
  id: '/tags',
  path: '/tags',
  getParentRoute: () => AdminKnowledgesRoute,
} as any)
const AdminKnowledgesCategoriesRoute =
  AdminKnowledgesCategoriesRouteImport.update({
    id: '/categories',
    path: '/categories',
    getParentRoute: () => AdminKnowledgesRoute,
  } as any)
const AdminKnowledgesKnowledgeIdRoute =
  AdminKnowledgesKnowledgeIdRouteImport.update({
    id: '/$knowledgeId',
    path: '/$knowledgeId',
    getParentRoute: () => AdminKnowledgesRoute,
  } as any)
const AdminFeatureDisabledCodeRoute =
  AdminFeatureDisabledCodeRouteImport.update({
    id: '/feature-disabled/$code',
    path: '/feature-disabled/$code',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminConnectorsTypesRoute = AdminConnectorsTypesRouteImport.update({
  id: '/types',
  path: '/types',
  getParentRoute: () => AdminConnectorsRoute,
} as any)
const AdminCheckpointsIdRoute = AdminCheckpointsIdRouteImport.update({
  id: '/checkpoints/$id',
  path: '/checkpoints/$id',
  getParentRoute: () => AdminRoute,
} as any)
const AdminPromptEngineTemplatesIndexRoute =
  AdminPromptEngineTemplatesIndexRouteImport.update({
    id: '/templates/',
    path: '/templates/',
    getParentRoute: () => AdminPromptEngineRoute,
  } as any)
const AdminPromptEngineTemplatesNewRoute =
  AdminPromptEngineTemplatesNewRouteImport.update({
    id: '/templates/new',
    path: '/templates/new',
    getParentRoute: () => AdminPromptEngineRoute,
  } as any)
const AdminPromptEngineTemplatesIdRoute =
  AdminPromptEngineTemplatesIdRouteImport.update({
    id: '/templates/$id',
    path: '/templates/$id',
    getParentRoute: () => AdminPromptEngineRoute,
  } as any)
const AdminKnowledgesKnowledgeIdRowFactsRoute =
  AdminKnowledgesKnowledgeIdRowFactsRouteImport.update({
    id: '/row-facts',
    path: '/row-facts',
    getParentRoute: () => AdminKnowledgesKnowledgeIdRoute,
  } as any)
const AdminWorkflowsIdRunsRunIdRoute =
  AdminWorkflowsIdRunsRunIdRouteImport.update({
    id: '/runs/$runId',
    path: '/runs/$runId',
    getParentRoute: () => AdminWorkflowsIdRoute,
  } as any)
const AdminSettingsUsersUserIdEffectivePermissionsRoute =
  AdminSettingsUsersUserIdEffectivePermissionsRouteImport.update({
    id: '/users/$userId/effective-permissions',
    path: '/users/$userId/effective-permissions',
    getParentRoute: () => AdminSettingsRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/403': typeof R403Route
  '/': typeof AdminIndexRoute
  '/account-suspended': typeof AccountSuspendedRoute
  '/awaiting-approval': typeof AwaitingApprovalRoute
  '/kb': typeof KbRouteWithChildren
  '/pending-approval': typeof PendingApprovalRoute
  '/system-admin': typeof SystemAdminRouteWithChildren
  '/verify-email': typeof VerifyEmailRoute
  '/account': typeof AdminAccountRoute
  '/categories': typeof AdminCategoriesRoute
  '/connector-types': typeof AdminConnectorTypesRoute
  '/connectors': typeof AdminConnectorsRouteWithChildren
  '/kg-graph': typeof AdminKgGraphRoute
  '/knowledges': typeof AdminKnowledgesRouteWithChildren
  '/llm': typeof AdminLlmRoute
  '/media-admin-settings': typeof AdminMediaAdminSettingsRoute
  '/my-api-keys': typeof AdminMyApiKeysRoute
  '/organizations': typeof AdminOrganizationsRoute
  '/prompt-engine': typeof AdminPromptEngineRouteWithChildren
  '/prompt-use-case-types': typeof AdminPromptUseCaseTypesRoute
  '/query-logs': typeof AdminQueryLogsRoute
  '/search': typeof AdminSearchRoute
  '/settings': typeof AdminSettingsRouteWithChildren
  '/tags': typeof AdminTagsRoute
  '/trash': typeof AdminTrashRoute
  '/usage-logs': typeof AdminUsageLogsRouteWithChildren
  '/forgot-password': typeof AuthForgotPasswordRoute
  '/invite': typeof AuthInviteRoute
  '/reset-password': typeof AuthResetPasswordRoute
  '/signin': typeof AuthSigninRoute
  '/signup': typeof AuthSignupRoute
  '/select-org': typeof OrgSetupSelectOrgRoute
  '/system-admin/admins': typeof SystemAdminAdminsRoute
  '/system-admin/audit': typeof SystemAdminAuditRoute
  '/system-admin/orgs': typeof SystemAdminOrgsRouteWithChildren
  '/system-admin/settings': typeof SystemAdminSettingsRoute
  '/system-admin/users': typeof SystemAdminUsersRoute
  '/system-admin/': typeof SystemAdminIndexRoute
  '/checkpoints/$id': typeof AdminCheckpointsIdRoute
  '/connectors/types': typeof AdminConnectorsTypesRoute
  '/feature-disabled/$code': typeof AdminFeatureDisabledCodeRoute
  '/knowledges/$knowledgeId': typeof AdminKnowledgesKnowledgeIdRouteWithChildren
  '/knowledges/categories': typeof AdminKnowledgesCategoriesRoute
  '/knowledges/tags': typeof AdminKnowledgesTagsRoute
  '/media/$assetId': typeof AdminMediaAssetIdRoute
  '/media/upload': typeof AdminMediaUploadRoute
  '/prompt-engine/use-cases': typeof AdminPromptEngineUseCasesRoute
  '/prompt-templates/$id': typeof AdminPromptTemplatesIdRoute
  '/prompt-templates/new': typeof AdminPromptTemplatesNewRoute
  '/settings/access-groups': typeof AdminSettingsAccessGroupsRoute
  '/settings/advanced': typeof AdminSettingsAdvancedRoute
  '/settings/ai-data-governance': typeof AdminSettingsAiDataGovernanceRoute
  '/settings/audit': typeof AdminSettingsAuditRoute
  '/settings/departments': typeof AdminSettingsDepartmentsRoute
  '/settings/general': typeof AdminSettingsGeneralRoute
  '/settings/info': typeof AdminSettingsInfoRoute
  '/settings/llm-cost': typeof AdminSettingsLlmCostRoute
  '/settings/media': typeof AdminSettingsMediaRoute
  '/settings/members': typeof AdminSettingsMembersRoute
  '/settings/notifications': typeof AdminSettingsNotificationsRoute
  '/settings/permissions': typeof AdminSettingsPermissionsRoute
  '/usage-logs/$callId': typeof AdminUsageLogsCallIdRoute
  '/workflows/$id': typeof AdminWorkflowsIdRouteWithChildren
  '/workflows/catalog': typeof AdminWorkflowsCatalogRoute
  '/kb/$orgSlug/$slug': typeof KbOrgSlugSlugRoute
  '/kb/share/$token': typeof KbShareTokenRoute
  '/system-admin/orgs/$orgId': typeof SystemAdminOrgsOrgIdRoute
  '/checkpoints/': typeof AdminCheckpointsIndexRoute
  '/connectors/': typeof AdminConnectorsIndexRoute
  '/knowledges/': typeof AdminKnowledgesIndexRoute
  '/media/': typeof AdminMediaIndexRoute
  '/prompt-engine/': typeof AdminPromptEngineIndexRoute
  '/prompt-templates/': typeof AdminPromptTemplatesIndexRoute
  '/settings/': typeof AdminSettingsIndexRoute
  '/workflows/': typeof AdminWorkflowsIndexRoute
  '/system-admin/orgs/': typeof SystemAdminOrgsIndexRoute
  '/knowledges/$knowledgeId/row-facts': typeof AdminKnowledgesKnowledgeIdRowFactsRoute
  '/prompt-engine/templates/$id': typeof AdminPromptEngineTemplatesIdRoute
  '/prompt-engine/templates/new': typeof AdminPromptEngineTemplatesNewRoute
  '/prompt-engine/templates/': typeof AdminPromptEngineTemplatesIndexRoute
  '/settings/users/$userId/effective-permissions': typeof AdminSettingsUsersUserIdEffectivePermissionsRoute
  '/workflows/$id/runs/$runId': typeof AdminWorkflowsIdRunsRunIdRoute
}
export interface FileRoutesByTo {
  '/403': typeof R403Route
  '/': typeof AdminIndexRoute
  '/account-suspended': typeof AccountSuspendedRoute
  '/awaiting-approval': typeof AwaitingApprovalRoute
  '/kb': typeof KbRouteWithChildren
  '/pending-approval': typeof PendingApprovalRoute
  '/verify-email': typeof VerifyEmailRoute
  '/account': typeof AdminAccountRoute
  '/categories': typeof AdminCategoriesRoute
  '/connector-types': typeof AdminConnectorTypesRoute
  '/kg-graph': typeof AdminKgGraphRoute
  '/llm': typeof AdminLlmRoute
  '/media-admin-settings': typeof AdminMediaAdminSettingsRoute
  '/my-api-keys': typeof AdminMyApiKeysRoute
  '/organizations': typeof AdminOrganizationsRoute
  '/prompt-use-case-types': typeof AdminPromptUseCaseTypesRoute
  '/query-logs': typeof AdminQueryLogsRoute
  '/search': typeof AdminSearchRoute
  '/tags': typeof AdminTagsRoute
  '/trash': typeof AdminTrashRoute
  '/usage-logs': typeof AdminUsageLogsRouteWithChildren
  '/forgot-password': typeof AuthForgotPasswordRoute
  '/invite': typeof AuthInviteRoute
  '/reset-password': typeof AuthResetPasswordRoute
  '/signin': typeof AuthSigninRoute
  '/signup': typeof AuthSignupRoute
  '/select-org': typeof OrgSetupSelectOrgRoute
  '/system-admin/admins': typeof SystemAdminAdminsRoute
  '/system-admin/audit': typeof SystemAdminAuditRoute
  '/system-admin/settings': typeof SystemAdminSettingsRoute
  '/system-admin/users': typeof SystemAdminUsersRoute
  '/system-admin': typeof SystemAdminIndexRoute
  '/checkpoints/$id': typeof AdminCheckpointsIdRoute
  '/connectors/types': typeof AdminConnectorsTypesRoute
  '/feature-disabled/$code': typeof AdminFeatureDisabledCodeRoute
  '/knowledges/$knowledgeId': typeof AdminKnowledgesKnowledgeIdRouteWithChildren
  '/knowledges/categories': typeof AdminKnowledgesCategoriesRoute
  '/knowledges/tags': typeof AdminKnowledgesTagsRoute
  '/media/$assetId': typeof AdminMediaAssetIdRoute
  '/media/upload': typeof AdminMediaUploadRoute
  '/prompt-engine/use-cases': typeof AdminPromptEngineUseCasesRoute
  '/prompt-templates/$id': typeof AdminPromptTemplatesIdRoute
  '/prompt-templates/new': typeof AdminPromptTemplatesNewRoute
  '/settings/access-groups': typeof AdminSettingsAccessGroupsRoute
  '/settings/advanced': typeof AdminSettingsAdvancedRoute
  '/settings/ai-data-governance': typeof AdminSettingsAiDataGovernanceRoute
  '/settings/audit': typeof AdminSettingsAuditRoute
  '/settings/departments': typeof AdminSettingsDepartmentsRoute
  '/settings/general': typeof AdminSettingsGeneralRoute
  '/settings/info': typeof AdminSettingsInfoRoute
  '/settings/llm-cost': typeof AdminSettingsLlmCostRoute
  '/settings/media': typeof AdminSettingsMediaRoute
  '/settings/members': typeof AdminSettingsMembersRoute
  '/settings/notifications': typeof AdminSettingsNotificationsRoute
  '/settings/permissions': typeof AdminSettingsPermissionsRoute
  '/usage-logs/$callId': typeof AdminUsageLogsCallIdRoute
  '/workflows/$id': typeof AdminWorkflowsIdRouteWithChildren
  '/workflows/catalog': typeof AdminWorkflowsCatalogRoute
  '/kb/$orgSlug/$slug': typeof KbOrgSlugSlugRoute
  '/kb/share/$token': typeof KbShareTokenRoute
  '/system-admin/orgs/$orgId': typeof SystemAdminOrgsOrgIdRoute
  '/checkpoints': typeof AdminCheckpointsIndexRoute
  '/connectors': typeof AdminConnectorsIndexRoute
  '/knowledges': typeof AdminKnowledgesIndexRoute
  '/media': typeof AdminMediaIndexRoute
  '/prompt-engine': typeof AdminPromptEngineIndexRoute
  '/prompt-templates': typeof AdminPromptTemplatesIndexRoute
  '/settings': typeof AdminSettingsIndexRoute
  '/workflows': typeof AdminWorkflowsIndexRoute
  '/system-admin/orgs': typeof SystemAdminOrgsIndexRoute
  '/knowledges/$knowledgeId/row-facts': typeof AdminKnowledgesKnowledgeIdRowFactsRoute
  '/prompt-engine/templates/$id': typeof AdminPromptEngineTemplatesIdRoute
  '/prompt-engine/templates/new': typeof AdminPromptEngineTemplatesNewRoute
  '/prompt-engine/templates': typeof AdminPromptEngineTemplatesIndexRoute
  '/settings/users/$userId/effective-permissions': typeof AdminSettingsUsersUserIdEffectivePermissionsRoute
  '/workflows/$id/runs/$runId': typeof AdminWorkflowsIdRunsRunIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/403': typeof R403Route
  '/_admin': typeof AdminRouteWithChildren
  '/_auth': typeof AuthRouteWithChildren
  '/_org-setup': typeof OrgSetupRouteWithChildren
  '/account-suspended': typeof AccountSuspendedRoute
  '/awaiting-approval': typeof AwaitingApprovalRoute
  '/kb': typeof KbRouteWithChildren
  '/pending-approval': typeof PendingApprovalRoute
  '/system-admin': typeof SystemAdminRouteWithChildren
  '/verify-email': typeof VerifyEmailRoute
  '/_admin/account': typeof AdminAccountRoute
  '/_admin/categories': typeof AdminCategoriesRoute
  '/_admin/connector-types': typeof AdminConnectorTypesRoute
  '/_admin/connectors': typeof AdminConnectorsRouteWithChildren
  '/_admin/kg-graph': typeof AdminKgGraphRoute
  '/_admin/knowledges': typeof AdminKnowledgesRouteWithChildren
  '/_admin/llm': typeof AdminLlmRoute
  '/_admin/media-admin-settings': typeof AdminMediaAdminSettingsRoute
  '/_admin/my-api-keys': typeof AdminMyApiKeysRoute
  '/_admin/organizations': typeof AdminOrganizationsRoute
  '/_admin/prompt-engine': typeof AdminPromptEngineRouteWithChildren
  '/_admin/prompt-use-case-types': typeof AdminPromptUseCaseTypesRoute
  '/_admin/query-logs': typeof AdminQueryLogsRoute
  '/_admin/search': typeof AdminSearchRoute
  '/_admin/settings': typeof AdminSettingsRouteWithChildren
  '/_admin/tags': typeof AdminTagsRoute
  '/_admin/trash': typeof AdminTrashRoute
  '/_admin/usage-logs': typeof AdminUsageLogsRouteWithChildren
  '/_auth/forgot-password': typeof AuthForgotPasswordRoute
  '/_auth/invite': typeof AuthInviteRoute
  '/_auth/reset-password': typeof AuthResetPasswordRoute
  '/_auth/signin': typeof AuthSigninRoute
  '/_auth/signup': typeof AuthSignupRoute
  '/_org-setup/select-org': typeof OrgSetupSelectOrgRoute
  '/system-admin/admins': typeof SystemAdminAdminsRoute
  '/system-admin/audit': typeof SystemAdminAuditRoute
  '/system-admin/orgs': typeof SystemAdminOrgsRouteWithChildren
  '/system-admin/settings': typeof SystemAdminSettingsRoute
  '/system-admin/users': typeof SystemAdminUsersRoute
  '/_admin/': typeof AdminIndexRoute
  '/system-admin/': typeof SystemAdminIndexRoute
  '/_admin/checkpoints/$id': typeof AdminCheckpointsIdRoute
  '/_admin/connectors/types': typeof AdminConnectorsTypesRoute
  '/_admin/feature-disabled/$code': typeof AdminFeatureDisabledCodeRoute
  '/_admin/knowledges/$knowledgeId': typeof AdminKnowledgesKnowledgeIdRouteWithChildren
  '/_admin/knowledges/categories': typeof AdminKnowledgesCategoriesRoute
  '/_admin/knowledges/tags': typeof AdminKnowledgesTagsRoute
  '/_admin/media/$assetId': typeof AdminMediaAssetIdRoute
  '/_admin/media/upload': typeof AdminMediaUploadRoute
  '/_admin/prompt-engine/use-cases': typeof AdminPromptEngineUseCasesRoute
  '/_admin/prompt-templates/$id': typeof AdminPromptTemplatesIdRoute
  '/_admin/prompt-templates/new': typeof AdminPromptTemplatesNewRoute
  '/_admin/settings/access-groups': typeof AdminSettingsAccessGroupsRoute
  '/_admin/settings/advanced': typeof AdminSettingsAdvancedRoute
  '/_admin/settings/ai-data-governance': typeof AdminSettingsAiDataGovernanceRoute
  '/_admin/settings/audit': typeof AdminSettingsAuditRoute
  '/_admin/settings/departments': typeof AdminSettingsDepartmentsRoute
  '/_admin/settings/general': typeof AdminSettingsGeneralRoute
  '/_admin/settings/info': typeof AdminSettingsInfoRoute
  '/_admin/settings/llm-cost': typeof AdminSettingsLlmCostRoute
  '/_admin/settings/media': typeof AdminSettingsMediaRoute
  '/_admin/settings/members': typeof AdminSettingsMembersRoute
  '/_admin/settings/notifications': typeof AdminSettingsNotificationsRoute
  '/_admin/settings/permissions': typeof AdminSettingsPermissionsRoute
  '/_admin/usage-logs/$callId': typeof AdminUsageLogsCallIdRoute
  '/_admin/workflows/$id': typeof AdminWorkflowsIdRouteWithChildren
  '/_admin/workflows/catalog': typeof AdminWorkflowsCatalogRoute
  '/kb/$orgSlug/$slug': typeof KbOrgSlugSlugRoute
  '/kb/share/$token': typeof KbShareTokenRoute
  '/system-admin/orgs/$orgId': typeof SystemAdminOrgsOrgIdRoute
  '/_admin/checkpoints/': typeof AdminCheckpointsIndexRoute
  '/_admin/connectors/': typeof AdminConnectorsIndexRoute
  '/_admin/knowledges/': typeof AdminKnowledgesIndexRoute
  '/_admin/media/': typeof AdminMediaIndexRoute
  '/_admin/prompt-engine/': typeof AdminPromptEngineIndexRoute
  '/_admin/prompt-templates/': typeof AdminPromptTemplatesIndexRoute
  '/_admin/settings/': typeof AdminSettingsIndexRoute
  '/_admin/workflows/': typeof AdminWorkflowsIndexRoute
  '/system-admin/orgs/': typeof SystemAdminOrgsIndexRoute
  '/_admin/knowledges/$knowledgeId/row-facts': typeof AdminKnowledgesKnowledgeIdRowFactsRoute
  '/_admin/prompt-engine/templates/$id': typeof AdminPromptEngineTemplatesIdRoute
  '/_admin/prompt-engine/templates/new': typeof AdminPromptEngineTemplatesNewRoute
  '/_admin/prompt-engine/templates/': typeof AdminPromptEngineTemplatesIndexRoute
  '/_admin/settings/users/$userId/effective-permissions': typeof AdminSettingsUsersUserIdEffectivePermissionsRoute
  '/_admin/workflows/$id/runs/$runId': typeof AdminWorkflowsIdRunsRunIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/403'
    | '/'
    | '/account-suspended'
    | '/awaiting-approval'
    | '/kb'
    | '/pending-approval'
    | '/system-admin'
    | '/verify-email'
    | '/account'
    | '/categories'
    | '/connector-types'
    | '/connectors'
    | '/kg-graph'
    | '/knowledges'
    | '/llm'
    | '/media-admin-settings'
    | '/my-api-keys'
    | '/organizations'
    | '/prompt-engine'
    | '/prompt-use-case-types'
    | '/query-logs'
    | '/search'
    | '/settings'
    | '/tags'
    | '/trash'
    | '/usage-logs'
    | '/forgot-password'
    | '/invite'
    | '/reset-password'
    | '/signin'
    | '/signup'
    | '/select-org'
    | '/system-admin/admins'
    | '/system-admin/audit'
    | '/system-admin/orgs'
    | '/system-admin/settings'
    | '/system-admin/users'
    | '/system-admin/'
    | '/checkpoints/$id'
    | '/connectors/types'
    | '/feature-disabled/$code'
    | '/knowledges/$knowledgeId'
    | '/knowledges/categories'
    | '/knowledges/tags'
    | '/media/$assetId'
    | '/media/upload'
    | '/prompt-engine/use-cases'
    | '/prompt-templates/$id'
    | '/prompt-templates/new'
    | '/settings/access-groups'
    | '/settings/advanced'
    | '/settings/ai-data-governance'
    | '/settings/audit'
    | '/settings/departments'
    | '/settings/general'
    | '/settings/info'
    | '/settings/llm-cost'
    | '/settings/media'
    | '/settings/members'
    | '/settings/notifications'
    | '/settings/permissions'
    | '/usage-logs/$callId'
    | '/workflows/$id'
    | '/workflows/catalog'
    | '/kb/$orgSlug/$slug'
    | '/kb/share/$token'
    | '/system-admin/orgs/$orgId'
    | '/checkpoints/'
    | '/connectors/'
    | '/knowledges/'
    | '/media/'
    | '/prompt-engine/'
    | '/prompt-templates/'
    | '/settings/'
    | '/workflows/'
    | '/system-admin/orgs/'
    | '/knowledges/$knowledgeId/row-facts'
    | '/prompt-engine/templates/$id'
    | '/prompt-engine/templates/new'
    | '/prompt-engine/templates/'
    | '/settings/users/$userId/effective-permissions'
    | '/workflows/$id/runs/$runId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/403'
    | '/'
    | '/account-suspended'
    | '/awaiting-approval'
    | '/kb'
    | '/pending-approval'
    | '/verify-email'
    | '/account'
    | '/categories'
    | '/connector-types'
    | '/kg-graph'
    | '/llm'
    | '/media-admin-settings'
    | '/my-api-keys'
    | '/organizations'
    | '/prompt-use-case-types'
    | '/query-logs'
    | '/search'
    | '/tags'
    | '/trash'
    | '/usage-logs'
    | '/forgot-password'
    | '/invite'
    | '/reset-password'
    | '/signin'
    | '/signup'
    | '/select-org'
    | '/system-admin/admins'
    | '/system-admin/audit'
    | '/system-admin/settings'
    | '/system-admin/users'
    | '/system-admin'
    | '/checkpoints/$id'
    | '/connectors/types'
    | '/feature-disabled/$code'
    | '/knowledges/$knowledgeId'
    | '/knowledges/categories'
    | '/knowledges/tags'
    | '/media/$assetId'
    | '/media/upload'
    | '/prompt-engine/use-cases'
    | '/prompt-templates/$id'
    | '/prompt-templates/new'
    | '/settings/access-groups'
    | '/settings/advanced'
    | '/settings/ai-data-governance'
    | '/settings/audit'
    | '/settings/departments'
    | '/settings/general'
    | '/settings/info'
    | '/settings/llm-cost'
    | '/settings/media'
    | '/settings/members'
    | '/settings/notifications'
    | '/settings/permissions'
    | '/usage-logs/$callId'
    | '/workflows/$id'
    | '/workflows/catalog'
    | '/kb/$orgSlug/$slug'
    | '/kb/share/$token'
    | '/system-admin/orgs/$orgId'
    | '/checkpoints'
    | '/connectors'
    | '/knowledges'
    | '/media'
    | '/prompt-engine'
    | '/prompt-templates'
    | '/settings'
    | '/workflows'
    | '/system-admin/orgs'
    | '/knowledges/$knowledgeId/row-facts'
    | '/prompt-engine/templates/$id'
    | '/prompt-engine/templates/new'
    | '/prompt-engine/templates'
    | '/settings/users/$userId/effective-permissions'
    | '/workflows/$id/runs/$runId'
  id:
    | '__root__'
    | '/403'
    | '/_admin'
    | '/_auth'
    | '/_org-setup'
    | '/account-suspended'
    | '/awaiting-approval'
    | '/kb'
    | '/pending-approval'
    | '/system-admin'
    | '/verify-email'
    | '/_admin/account'
    | '/_admin/categories'
    | '/_admin/connector-types'
    | '/_admin/connectors'
    | '/_admin/kg-graph'
    | '/_admin/knowledges'
    | '/_admin/llm'
    | '/_admin/media-admin-settings'
    | '/_admin/my-api-keys'
    | '/_admin/organizations'
    | '/_admin/prompt-engine'
    | '/_admin/prompt-use-case-types'
    | '/_admin/query-logs'
    | '/_admin/search'
    | '/_admin/settings'
    | '/_admin/tags'
    | '/_admin/trash'
    | '/_admin/usage-logs'
    | '/_auth/forgot-password'
    | '/_auth/invite'
    | '/_auth/reset-password'
    | '/_auth/signin'
    | '/_auth/signup'
    | '/_org-setup/select-org'
    | '/system-admin/admins'
    | '/system-admin/audit'
    | '/system-admin/orgs'
    | '/system-admin/settings'
    | '/system-admin/users'
    | '/_admin/'
    | '/system-admin/'
    | '/_admin/checkpoints/$id'
    | '/_admin/connectors/types'
    | '/_admin/feature-disabled/$code'
    | '/_admin/knowledges/$knowledgeId'
    | '/_admin/knowledges/categories'
    | '/_admin/knowledges/tags'
    | '/_admin/media/$assetId'
    | '/_admin/media/upload'
    | '/_admin/prompt-engine/use-cases'
    | '/_admin/prompt-templates/$id'
    | '/_admin/prompt-templates/new'
    | '/_admin/settings/access-groups'
    | '/_admin/settings/advanced'
    | '/_admin/settings/ai-data-governance'
    | '/_admin/settings/audit'
    | '/_admin/settings/departments'
    | '/_admin/settings/general'
    | '/_admin/settings/info'
    | '/_admin/settings/llm-cost'
    | '/_admin/settings/media'
    | '/_admin/settings/members'
    | '/_admin/settings/notifications'
    | '/_admin/settings/permissions'
    | '/_admin/usage-logs/$callId'
    | '/_admin/workflows/$id'
    | '/_admin/workflows/catalog'
    | '/kb/$orgSlug/$slug'
    | '/kb/share/$token'
    | '/system-admin/orgs/$orgId'
    | '/_admin/checkpoints/'
    | '/_admin/connectors/'
    | '/_admin/knowledges/'
    | '/_admin/media/'
    | '/_admin/prompt-engine/'
    | '/_admin/prompt-templates/'
    | '/_admin/settings/'
    | '/_admin/workflows/'
    | '/system-admin/orgs/'
    | '/_admin/knowledges/$knowledgeId/row-facts'
    | '/_admin/prompt-engine/templates/$id'
    | '/_admin/prompt-engine/templates/new'
    | '/_admin/prompt-engine/templates/'
    | '/_admin/settings/users/$userId/effective-permissions'
    | '/_admin/workflows/$id/runs/$runId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  R403Route: typeof R403Route
  AdminRoute: typeof AdminRouteWithChildren
  AuthRoute: typeof AuthRouteWithChildren
  OrgSetupRoute: typeof OrgSetupRouteWithChildren
  AccountSuspendedRoute: typeof AccountSuspendedRoute
  AwaitingApprovalRoute: typeof AwaitingApprovalRoute
  KbRoute: typeof KbRouteWithChildren
  PendingApprovalRoute: typeof PendingApprovalRoute
  SystemAdminRoute: typeof SystemAdminRouteWithChildren
  VerifyEmailRoute: typeof VerifyEmailRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/verify-email': {
      id: '/verify-email'
      path: '/verify-email'
      fullPath: '/verify-email'
      preLoaderRoute: typeof VerifyEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/system-admin': {
      id: '/system-admin'
      path: '/system-admin'
      fullPath: '/system-admin'
      preLoaderRoute: typeof SystemAdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pending-approval': {
      id: '/pending-approval'
      path: '/pending-approval'
      fullPath: '/pending-approval'
      preLoaderRoute: typeof PendingApprovalRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/kb': {
      id: '/kb'
      path: '/kb'
      fullPath: '/kb'
      preLoaderRoute: typeof KbRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/awaiting-approval': {
      id: '/awaiting-approval'
      path: '/awaiting-approval'
      fullPath: '/awaiting-approval'
      preLoaderRoute: typeof AwaitingApprovalRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account-suspended': {
      id: '/account-suspended'
      path: '/account-suspended'
      fullPath: '/account-suspended'
      preLoaderRoute: typeof AccountSuspendedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_org-setup': {
      id: '/_org-setup'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof OrgSetupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_admin': {
      id: '/_admin'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/403': {
      id: '/403'
      path: '/403'
      fullPath: '/403'
      preLoaderRoute: typeof R403RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/system-admin/': {
      id: '/system-admin/'
      path: '/'
      fullPath: '/system-admin/'
      preLoaderRoute: typeof SystemAdminIndexRouteImport
      parentRoute: typeof SystemAdminRoute
    }
    '/_admin/': {
      id: '/_admin/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/system-admin/users': {
      id: '/system-admin/users'
      path: '/users'
      fullPath: '/system-admin/users'
      preLoaderRoute: typeof SystemAdminUsersRouteImport
      parentRoute: typeof SystemAdminRoute
    }
    '/system-admin/settings': {
      id: '/system-admin/settings'
      path: '/settings'
      fullPath: '/system-admin/settings'
      preLoaderRoute: typeof SystemAdminSettingsRouteImport
      parentRoute: typeof SystemAdminRoute
    }
    '/system-admin/orgs': {
      id: '/system-admin/orgs'
      path: '/orgs'
      fullPath: '/system-admin/orgs'
      preLoaderRoute: typeof SystemAdminOrgsRouteImport
      parentRoute: typeof SystemAdminRoute
    }
    '/system-admin/audit': {
      id: '/system-admin/audit'
      path: '/audit'
      fullPath: '/system-admin/audit'
      preLoaderRoute: typeof SystemAdminAuditRouteImport
      parentRoute: typeof SystemAdminRoute
    }
    '/system-admin/admins': {
      id: '/system-admin/admins'
      path: '/admins'
      fullPath: '/system-admin/admins'
      preLoaderRoute: typeof SystemAdminAdminsRouteImport
      parentRoute: typeof SystemAdminRoute
    }
    '/_org-setup/select-org': {
      id: '/_org-setup/select-org'
      path: '/select-org'
      fullPath: '/select-org'
      preLoaderRoute: typeof OrgSetupSelectOrgRouteImport
      parentRoute: typeof OrgSetupRoute
    }
    '/_auth/signup': {
      id: '/_auth/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof AuthSignupRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/signin': {
      id: '/_auth/signin'
      path: '/signin'
      fullPath: '/signin'
      preLoaderRoute: typeof AuthSigninRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/reset-password': {
      id: '/_auth/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof AuthResetPasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/invite': {
      id: '/_auth/invite'
      path: '/invite'
      fullPath: '/invite'
      preLoaderRoute: typeof AuthInviteRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/forgot-password': {
      id: '/_auth/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof AuthForgotPasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_admin/usage-logs': {
      id: '/_admin/usage-logs'
      path: '/usage-logs'
      fullPath: '/usage-logs'
      preLoaderRoute: typeof AdminUsageLogsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/trash': {
      id: '/_admin/trash'
      path: '/trash'
      fullPath: '/trash'
      preLoaderRoute: typeof AdminTrashRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/tags': {
      id: '/_admin/tags'
      path: '/tags'
      fullPath: '/tags'
      preLoaderRoute: typeof AdminTagsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/settings': {
      id: '/_admin/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AdminSettingsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/search': {
      id: '/_admin/search'
      path: '/search'
      fullPath: '/search'
      preLoaderRoute: typeof AdminSearchRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/query-logs': {
      id: '/_admin/query-logs'
      path: '/query-logs'
      fullPath: '/query-logs'
      preLoaderRoute: typeof AdminQueryLogsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/prompt-use-case-types': {
      id: '/_admin/prompt-use-case-types'
      path: '/prompt-use-case-types'
      fullPath: '/prompt-use-case-types'
      preLoaderRoute: typeof AdminPromptUseCaseTypesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/prompt-engine': {
      id: '/_admin/prompt-engine'
      path: '/prompt-engine'
      fullPath: '/prompt-engine'
      preLoaderRoute: typeof AdminPromptEngineRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/organizations': {
      id: '/_admin/organizations'
      path: '/organizations'
      fullPath: '/organizations'
      preLoaderRoute: typeof AdminOrganizationsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/my-api-keys': {
      id: '/_admin/my-api-keys'
      path: '/my-api-keys'
      fullPath: '/my-api-keys'
      preLoaderRoute: typeof AdminMyApiKeysRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/media-admin-settings': {
      id: '/_admin/media-admin-settings'
      path: '/media-admin-settings'
      fullPath: '/media-admin-settings'
      preLoaderRoute: typeof AdminMediaAdminSettingsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/llm': {
      id: '/_admin/llm'
      path: '/llm'
      fullPath: '/llm'
      preLoaderRoute: typeof AdminLlmRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/knowledges': {
      id: '/_admin/knowledges'
      path: '/knowledges'
      fullPath: '/knowledges'
      preLoaderRoute: typeof AdminKnowledgesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/kg-graph': {
      id: '/_admin/kg-graph'
      path: '/kg-graph'
      fullPath: '/kg-graph'
      preLoaderRoute: typeof AdminKgGraphRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/connectors': {
      id: '/_admin/connectors'
      path: '/connectors'
      fullPath: '/connectors'
      preLoaderRoute: typeof AdminConnectorsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/connector-types': {
      id: '/_admin/connector-types'
      path: '/connector-types'
      fullPath: '/connector-types'
      preLoaderRoute: typeof AdminConnectorTypesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/categories': {
      id: '/_admin/categories'
      path: '/categories'
      fullPath: '/categories'
      preLoaderRoute: typeof AdminCategoriesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/account': {
      id: '/_admin/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AdminAccountRouteImport
      parentRoute: typeof AdminRoute
    }
    '/system-admin/orgs/': {
      id: '/system-admin/orgs/'
      path: '/'
      fullPath: '/system-admin/orgs/'
      preLoaderRoute: typeof SystemAdminOrgsIndexRouteImport
      parentRoute: typeof SystemAdminOrgsRoute
    }
    '/_admin/workflows/': {
      id: '/_admin/workflows/'
      path: '/workflows'
      fullPath: '/workflows/'
      preLoaderRoute: typeof AdminWorkflowsIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/settings/': {
      id: '/_admin/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AdminSettingsIndexRouteImport
      parentRoute: typeof AdminSettingsRoute
    }
    '/_admin/prompt-templates/': {
      id: '/_admin/prompt-templates/'
      path: '/prompt-templates'
      fullPath: '/prompt-templates/'
      preLoaderRoute: typeof AdminPromptTemplatesIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/prompt-engine/': {
      id: '/_admin/prompt-engine/'
      path: '/'
      fullPath: '/prompt-engine/'
      preLoaderRoute: typeof AdminPromptEngineIndexRouteImport
      parentRoute: typeof AdminPromptEngineRoute
    }
    '/_admin/media/': {
      id: '/_admin/media/'
      path: '/media'
      fullPath: '/media/'
      preLoaderRoute: typeof AdminMediaIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/knowledges/': {
      id: '/_admin/knowledges/'
      path: '/'
      fullPath: '/knowledges/'
      preLoaderRoute: typeof AdminKnowledgesIndexRouteImport
      parentRoute: typeof AdminKnowledgesRoute
    }
    '/_admin/connectors/': {
      id: '/_admin/connectors/'
      path: '/'
      fullPath: '/connectors/'
      preLoaderRoute: typeof AdminConnectorsIndexRouteImport
      parentRoute: typeof AdminConnectorsRoute
    }
    '/_admin/checkpoints/': {
      id: '/_admin/checkpoints/'
      path: '/checkpoints'
      fullPath: '/checkpoints/'
      preLoaderRoute: typeof AdminCheckpointsIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/system-admin/orgs/$orgId': {
      id: '/system-admin/orgs/$orgId'
      path: '/$orgId'
      fullPath: '/system-admin/orgs/$orgId'
      preLoaderRoute: typeof SystemAdminOrgsOrgIdRouteImport
      parentRoute: typeof SystemAdminOrgsRoute
    }
    '/kb/share/$token': {
      id: '/kb/share/$token'
      path: '/share/$token'
      fullPath: '/kb/share/$token'
      preLoaderRoute: typeof KbShareTokenRouteImport
      parentRoute: typeof KbRoute
    }
    '/kb/$orgSlug/$slug': {
      id: '/kb/$orgSlug/$slug'
      path: '/$orgSlug/$slug'
      fullPath: '/kb/$orgSlug/$slug'
      preLoaderRoute: typeof KbOrgSlugSlugRouteImport
      parentRoute: typeof KbRoute
    }
    '/_admin/workflows/catalog': {
      id: '/_admin/workflows/catalog'
      path: '/workflows/catalog'
      fullPath: '/workflows/catalog'
      preLoaderRoute: typeof AdminWorkflowsCatalogRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/workflows/$id': {
      id: '/_admin/workflows/$id'
      path: '/workflows/$id'
      fullPath: '/workflows/$id'
      preLoaderRoute: typeof AdminWorkflowsIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/usage-logs/$callId': {
      id: '/_admin/usage-logs/$callId'
      path: '/$callId'
      fullPath: '/usage-logs/$callId'
      preLoaderRoute: typeof AdminUsageLogsCallIdRouteImport
      parentRoute: typeof AdminUsageLogsRoute
    }
    '/_admin/settings/permissions': {
      id: '/_admin/settings/permissions'
      path: '/permissions'
      fullPath: '/settings/permissions'
      preLoaderRoute: typeof AdminSettingsPermissionsRouteImport
      parentRoute: typeof AdminSettingsRoute
    }
    '/_admin/settings/notifications': {
      id: '/_admin/settings/notifications'
      path: '/notifications'
      fullPath: '/settings/notifications'
      preLoaderRoute: typeof AdminSettingsNotificationsRouteImport
      parentRoute: typeof AdminSettingsRoute
    }
    '/_admin/settings/members': {
      id: '/_admin/settings/members'
      path: '/members'
      fullPath: '/settings/members'
      preLoaderRoute: typeof AdminSettingsMembersRouteImport
      parentRoute: typeof AdminSettingsRoute
    }
    '/_admin/settings/media': {
      id: '/_admin/settings/media'
      path: '/media'
      fullPath: '/settings/media'
      preLoaderRoute: typeof AdminSettingsMediaRouteImport
      parentRoute: typeof AdminSettingsRoute
    }
    '/_admin/settings/llm-cost': {
      id: '/_admin/settings/llm-cost'
      path: '/llm-cost'
      fullPath: '/settings/llm-cost'
      preLoaderRoute: typeof AdminSettingsLlmCostRouteImport
      parentRoute: typeof AdminSettingsRoute
    }
    '/_admin/settings/info': {
      id: '/_admin/settings/info'
      path: '/info'
      fullPath: '/settings/info'
      preLoaderRoute: typeof AdminSettingsInfoRouteImport
      parentRoute: typeof AdminSettingsRoute
    }
    '/_admin/settings/general': {
      id: '/_admin/settings/general'
      path: '/general'
      fullPath: '/settings/general'
      preLoaderRoute: typeof AdminSettingsGeneralRouteImport
      parentRoute: typeof AdminSettingsRoute
    }
    '/_admin/settings/departments': {
      id: '/_admin/settings/departments'
      path: '/departments'
      fullPath: '/settings/departments'
      preLoaderRoute: typeof AdminSettingsDepartmentsRouteImport
      parentRoute: typeof AdminSettingsRoute
    }
    '/_admin/settings/audit': {
      id: '/_admin/settings/audit'
      path: '/audit'
      fullPath: '/settings/audit'
      preLoaderRoute: typeof AdminSettingsAuditRouteImport
      parentRoute: typeof AdminSettingsRoute
    }
    '/_admin/settings/ai-data-governance': {
      id: '/_admin/settings/ai-data-governance'
      path: '/ai-data-governance'
      fullPath: '/settings/ai-data-governance'
      preLoaderRoute: typeof AdminSettingsAiDataGovernanceRouteImport
      parentRoute: typeof AdminSettingsRoute
    }
    '/_admin/settings/advanced': {
      id: '/_admin/settings/advanced'
      path: '/advanced'
      fullPath: '/settings/advanced'
      preLoaderRoute: typeof AdminSettingsAdvancedRouteImport
      parentRoute: typeof AdminSettingsRoute
    }
    '/_admin/settings/access-groups': {
      id: '/_admin/settings/access-groups'
      path: '/access-groups'
      fullPath: '/settings/access-groups'
      preLoaderRoute: typeof AdminSettingsAccessGroupsRouteImport
      parentRoute: typeof AdminSettingsRoute
    }
    '/_admin/prompt-templates/new': {
      id: '/_admin/prompt-templates/new'
      path: '/prompt-templates/new'
      fullPath: '/prompt-templates/new'
      preLoaderRoute: typeof AdminPromptTemplatesNewRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/prompt-templates/$id': {
      id: '/_admin/prompt-templates/$id'
      path: '/prompt-templates/$id'
      fullPath: '/prompt-templates/$id'
      preLoaderRoute: typeof AdminPromptTemplatesIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/prompt-engine/use-cases': {
      id: '/_admin/prompt-engine/use-cases'
      path: '/use-cases'
      fullPath: '/prompt-engine/use-cases'
      preLoaderRoute: typeof AdminPromptEngineUseCasesRouteImport
      parentRoute: typeof AdminPromptEngineRoute
    }
    '/_admin/media/upload': {
      id: '/_admin/media/upload'
      path: '/media/upload'
      fullPath: '/media/upload'
      preLoaderRoute: typeof AdminMediaUploadRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/media/$assetId': {
      id: '/_admin/media/$assetId'
      path: '/media/$assetId'
      fullPath: '/media/$assetId'
      preLoaderRoute: typeof AdminMediaAssetIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/knowledges/tags': {
      id: '/_admin/knowledges/tags'
      path: '/tags'
      fullPath: '/knowledges/tags'
      preLoaderRoute: typeof AdminKnowledgesTagsRouteImport
      parentRoute: typeof AdminKnowledgesRoute
    }
    '/_admin/knowledges/categories': {
      id: '/_admin/knowledges/categories'
      path: '/categories'
      fullPath: '/knowledges/categories'
      preLoaderRoute: typeof AdminKnowledgesCategoriesRouteImport
      parentRoute: typeof AdminKnowledgesRoute
    }
    '/_admin/knowledges/$knowledgeId': {
      id: '/_admin/knowledges/$knowledgeId'
      path: '/$knowledgeId'
      fullPath: '/knowledges/$knowledgeId'
      preLoaderRoute: typeof AdminKnowledgesKnowledgeIdRouteImport
      parentRoute: typeof AdminKnowledgesRoute
    }
    '/_admin/feature-disabled/$code': {
      id: '/_admin/feature-disabled/$code'
      path: '/feature-disabled/$code'
      fullPath: '/feature-disabled/$code'
      preLoaderRoute: typeof AdminFeatureDisabledCodeRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/connectors/types': {
      id: '/_admin/connectors/types'
      path: '/types'
      fullPath: '/connectors/types'
      preLoaderRoute: typeof AdminConnectorsTypesRouteImport
      parentRoute: typeof AdminConnectorsRoute
    }
    '/_admin/checkpoints/$id': {
      id: '/_admin/checkpoints/$id'
      path: '/checkpoints/$id'
      fullPath: '/checkpoints/$id'
      preLoaderRoute: typeof AdminCheckpointsIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/prompt-engine/templates/': {
      id: '/_admin/prompt-engine/templates/'
      path: '/templates'
      fullPath: '/prompt-engine/templates/'
      preLoaderRoute: typeof AdminPromptEngineTemplatesIndexRouteImport
      parentRoute: typeof AdminPromptEngineRoute
    }
    '/_admin/prompt-engine/templates/new': {
      id: '/_admin/prompt-engine/templates/new'
      path: '/templates/new'
      fullPath: '/prompt-engine/templates/new'
      preLoaderRoute: typeof AdminPromptEngineTemplatesNewRouteImport
      parentRoute: typeof AdminPromptEngineRoute
    }
    '/_admin/prompt-engine/templates/$id': {
      id: '/_admin/prompt-engine/templates/$id'
      path: '/templates/$id'
      fullPath: '/prompt-engine/templates/$id'
      preLoaderRoute: typeof AdminPromptEngineTemplatesIdRouteImport
      parentRoute: typeof AdminPromptEngineRoute
    }
    '/_admin/knowledges/$knowledgeId/row-facts': {
      id: '/_admin/knowledges/$knowledgeId/row-facts'
      path: '/row-facts'
      fullPath: '/knowledges/$knowledgeId/row-facts'
      preLoaderRoute: typeof AdminKnowledgesKnowledgeIdRowFactsRouteImport
      parentRoute: typeof AdminKnowledgesKnowledgeIdRoute
    }
    '/_admin/workflows/$id/runs/$runId': {
      id: '/_admin/workflows/$id/runs/$runId'
      path: '/runs/$runId'
      fullPath: '/workflows/$id/runs/$runId'
      preLoaderRoute: typeof AdminWorkflowsIdRunsRunIdRouteImport
      parentRoute: typeof AdminWorkflowsIdRoute
    }
    '/_admin/settings/users/$userId/effective-permissions': {
      id: '/_admin/settings/users/$userId/effective-permissions'
      path: '/users/$userId/effective-permissions'
      fullPath: '/settings/users/$userId/effective-permissions'
      preLoaderRoute: typeof AdminSettingsUsersUserIdEffectivePermissionsRouteImport
      parentRoute: typeof AdminSettingsRoute
    }
  }
}

interface AdminConnectorsRouteChildren {
  AdminConnectorsTypesRoute: typeof AdminConnectorsTypesRoute
  AdminConnectorsIndexRoute: typeof AdminConnectorsIndexRoute
}

const AdminConnectorsRouteChildren: AdminConnectorsRouteChildren = {
  AdminConnectorsTypesRoute: AdminConnectorsTypesRoute,
  AdminConnectorsIndexRoute: AdminConnectorsIndexRoute,
}

const AdminConnectorsRouteWithChildren = AdminConnectorsRoute._addFileChildren(
  AdminConnectorsRouteChildren,
)

interface AdminKnowledgesKnowledgeIdRouteChildren {
  AdminKnowledgesKnowledgeIdRowFactsRoute: typeof AdminKnowledgesKnowledgeIdRowFactsRoute
}

const AdminKnowledgesKnowledgeIdRouteChildren: AdminKnowledgesKnowledgeIdRouteChildren =
  {
    AdminKnowledgesKnowledgeIdRowFactsRoute:
      AdminKnowledgesKnowledgeIdRowFactsRoute,
  }

const AdminKnowledgesKnowledgeIdRouteWithChildren =
  AdminKnowledgesKnowledgeIdRoute._addFileChildren(
    AdminKnowledgesKnowledgeIdRouteChildren,
  )

interface AdminKnowledgesRouteChildren {
  AdminKnowledgesKnowledgeIdRoute: typeof AdminKnowledgesKnowledgeIdRouteWithChildren
  AdminKnowledgesCategoriesRoute: typeof AdminKnowledgesCategoriesRoute
  AdminKnowledgesTagsRoute: typeof AdminKnowledgesTagsRoute
  AdminKnowledgesIndexRoute: typeof AdminKnowledgesIndexRoute
}

const AdminKnowledgesRouteChildren: AdminKnowledgesRouteChildren = {
  AdminKnowledgesKnowledgeIdRoute: AdminKnowledgesKnowledgeIdRouteWithChildren,
  AdminKnowledgesCategoriesRoute: AdminKnowledgesCategoriesRoute,
  AdminKnowledgesTagsRoute: AdminKnowledgesTagsRoute,
  AdminKnowledgesIndexRoute: AdminKnowledgesIndexRoute,
}

const AdminKnowledgesRouteWithChildren = AdminKnowledgesRoute._addFileChildren(
  AdminKnowledgesRouteChildren,
)

interface AdminPromptEngineRouteChildren {
  AdminPromptEngineUseCasesRoute: typeof AdminPromptEngineUseCasesRoute
  AdminPromptEngineIndexRoute: typeof AdminPromptEngineIndexRoute
  AdminPromptEngineTemplatesIdRoute: typeof AdminPromptEngineTemplatesIdRoute
  AdminPromptEngineTemplatesNewRoute: typeof AdminPromptEngineTemplatesNewRoute
  AdminPromptEngineTemplatesIndexRoute: typeof AdminPromptEngineTemplatesIndexRoute
}

const AdminPromptEngineRouteChildren: AdminPromptEngineRouteChildren = {
  AdminPromptEngineUseCasesRoute: AdminPromptEngineUseCasesRoute,
  AdminPromptEngineIndexRoute: AdminPromptEngineIndexRoute,
  AdminPromptEngineTemplatesIdRoute: AdminPromptEngineTemplatesIdRoute,
  AdminPromptEngineTemplatesNewRoute: AdminPromptEngineTemplatesNewRoute,
  AdminPromptEngineTemplatesIndexRoute: AdminPromptEngineTemplatesIndexRoute,
}

const AdminPromptEngineRouteWithChildren =
  AdminPromptEngineRoute._addFileChildren(AdminPromptEngineRouteChildren)

interface AdminSettingsRouteChildren {
  AdminSettingsAccessGroupsRoute: typeof AdminSettingsAccessGroupsRoute
  AdminSettingsAdvancedRoute: typeof AdminSettingsAdvancedRoute
  AdminSettingsAiDataGovernanceRoute: typeof AdminSettingsAiDataGovernanceRoute
  AdminSettingsAuditRoute: typeof AdminSettingsAuditRoute
  AdminSettingsDepartmentsRoute: typeof AdminSettingsDepartmentsRoute
  AdminSettingsGeneralRoute: typeof AdminSettingsGeneralRoute
  AdminSettingsInfoRoute: typeof AdminSettingsInfoRoute
  AdminSettingsLlmCostRoute: typeof AdminSettingsLlmCostRoute
  AdminSettingsMediaRoute: typeof AdminSettingsMediaRoute
  AdminSettingsMembersRoute: typeof AdminSettingsMembersRoute
  AdminSettingsNotificationsRoute: typeof AdminSettingsNotificationsRoute
  AdminSettingsPermissionsRoute: typeof AdminSettingsPermissionsRoute
  AdminSettingsIndexRoute: typeof AdminSettingsIndexRoute
  AdminSettingsUsersUserIdEffectivePermissionsRoute: typeof AdminSettingsUsersUserIdEffectivePermissionsRoute
}

const AdminSettingsRouteChildren: AdminSettingsRouteChildren = {
  AdminSettingsAccessGroupsRoute: AdminSettingsAccessGroupsRoute,
  AdminSettingsAdvancedRoute: AdminSettingsAdvancedRoute,
  AdminSettingsAiDataGovernanceRoute: AdminSettingsAiDataGovernanceRoute,
  AdminSettingsAuditRoute: AdminSettingsAuditRoute,
  AdminSettingsDepartmentsRoute: AdminSettingsDepartmentsRoute,
  AdminSettingsGeneralRoute: AdminSettingsGeneralRoute,
  AdminSettingsInfoRoute: AdminSettingsInfoRoute,
  AdminSettingsLlmCostRoute: AdminSettingsLlmCostRoute,
  AdminSettingsMediaRoute: AdminSettingsMediaRoute,
  AdminSettingsMembersRoute: AdminSettingsMembersRoute,
  AdminSettingsNotificationsRoute: AdminSettingsNotificationsRoute,
  AdminSettingsPermissionsRoute: AdminSettingsPermissionsRoute,
  AdminSettingsIndexRoute: AdminSettingsIndexRoute,
  AdminSettingsUsersUserIdEffectivePermissionsRoute:
    AdminSettingsUsersUserIdEffectivePermissionsRoute,
}

const AdminSettingsRouteWithChildren = AdminSettingsRoute._addFileChildren(
  AdminSettingsRouteChildren,
)

interface AdminUsageLogsRouteChildren {
  AdminUsageLogsCallIdRoute: typeof AdminUsageLogsCallIdRoute
}

const AdminUsageLogsRouteChildren: AdminUsageLogsRouteChildren = {
  AdminUsageLogsCallIdRoute: AdminUsageLogsCallIdRoute,
}

const AdminUsageLogsRouteWithChildren = AdminUsageLogsRoute._addFileChildren(
  AdminUsageLogsRouteChildren,
)

interface AdminWorkflowsIdRouteChildren {
  AdminWorkflowsIdRunsRunIdRoute: typeof AdminWorkflowsIdRunsRunIdRoute
}

const AdminWorkflowsIdRouteChildren: AdminWorkflowsIdRouteChildren = {
  AdminWorkflowsIdRunsRunIdRoute: AdminWorkflowsIdRunsRunIdRoute,
}

const AdminWorkflowsIdRouteWithChildren =
  AdminWorkflowsIdRoute._addFileChildren(AdminWorkflowsIdRouteChildren)

interface AdminRouteChildren {
  AdminAccountRoute: typeof AdminAccountRoute
  AdminCategoriesRoute: typeof AdminCategoriesRoute
  AdminConnectorTypesRoute: typeof AdminConnectorTypesRoute
  AdminConnectorsRoute: typeof AdminConnectorsRouteWithChildren
  AdminKgGraphRoute: typeof AdminKgGraphRoute
  AdminKnowledgesRoute: typeof AdminKnowledgesRouteWithChildren
  AdminLlmRoute: typeof AdminLlmRoute
  AdminMediaAdminSettingsRoute: typeof AdminMediaAdminSettingsRoute
  AdminMyApiKeysRoute: typeof AdminMyApiKeysRoute
  AdminOrganizationsRoute: typeof AdminOrganizationsRoute
  AdminPromptEngineRoute: typeof AdminPromptEngineRouteWithChildren
  AdminPromptUseCaseTypesRoute: typeof AdminPromptUseCaseTypesRoute
  AdminQueryLogsRoute: typeof AdminQueryLogsRoute
  AdminSearchRoute: typeof AdminSearchRoute
  AdminSettingsRoute: typeof AdminSettingsRouteWithChildren
  AdminTagsRoute: typeof AdminTagsRoute
  AdminTrashRoute: typeof AdminTrashRoute
  AdminUsageLogsRoute: typeof AdminUsageLogsRouteWithChildren
  AdminIndexRoute: typeof AdminIndexRoute
  AdminCheckpointsIdRoute: typeof AdminCheckpointsIdRoute
  AdminFeatureDisabledCodeRoute: typeof AdminFeatureDisabledCodeRoute
  AdminMediaAssetIdRoute: typeof AdminMediaAssetIdRoute
  AdminMediaUploadRoute: typeof AdminMediaUploadRoute
  AdminPromptTemplatesIdRoute: typeof AdminPromptTemplatesIdRoute
  AdminPromptTemplatesNewRoute: typeof AdminPromptTemplatesNewRoute
  AdminWorkflowsIdRoute: typeof AdminWorkflowsIdRouteWithChildren
  AdminWorkflowsCatalogRoute: typeof AdminWorkflowsCatalogRoute
  AdminCheckpointsIndexRoute: typeof AdminCheckpointsIndexRoute
  AdminMediaIndexRoute: typeof AdminMediaIndexRoute
  AdminPromptTemplatesIndexRoute: typeof AdminPromptTemplatesIndexRoute
  AdminWorkflowsIndexRoute: typeof AdminWorkflowsIndexRoute
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminAccountRoute: AdminAccountRoute,
  AdminCategoriesRoute: AdminCategoriesRoute,
  AdminConnectorTypesRoute: AdminConnectorTypesRoute,
  AdminConnectorsRoute: AdminConnectorsRouteWithChildren,
  AdminKgGraphRoute: AdminKgGraphRoute,
  AdminKnowledgesRoute: AdminKnowledgesRouteWithChildren,
  AdminLlmRoute: AdminLlmRoute,
  AdminMediaAdminSettingsRoute: AdminMediaAdminSettingsRoute,
  AdminMyApiKeysRoute: AdminMyApiKeysRoute,
  AdminOrganizationsRoute: AdminOrganizationsRoute,
  AdminPromptEngineRoute: AdminPromptEngineRouteWithChildren,
  AdminPromptUseCaseTypesRoute: AdminPromptUseCaseTypesRoute,
  AdminQueryLogsRoute: AdminQueryLogsRoute,
  AdminSearchRoute: AdminSearchRoute,
  AdminSettingsRoute: AdminSettingsRouteWithChildren,
  AdminTagsRoute: AdminTagsRoute,
  AdminTrashRoute: AdminTrashRoute,
  AdminUsageLogsRoute: AdminUsageLogsRouteWithChildren,
  AdminIndexRoute: AdminIndexRoute,
  AdminCheckpointsIdRoute: AdminCheckpointsIdRoute,
  AdminFeatureDisabledCodeRoute: AdminFeatureDisabledCodeRoute,
  AdminMediaAssetIdRoute: AdminMediaAssetIdRoute,
  AdminMediaUploadRoute: AdminMediaUploadRoute,
  AdminPromptTemplatesIdRoute: AdminPromptTemplatesIdRoute,
  AdminPromptTemplatesNewRoute: AdminPromptTemplatesNewRoute,
  AdminWorkflowsIdRoute: AdminWorkflowsIdRouteWithChildren,
  AdminWorkflowsCatalogRoute: AdminWorkflowsCatalogRoute,
  AdminCheckpointsIndexRoute: AdminCheckpointsIndexRoute,
  AdminMediaIndexRoute: AdminMediaIndexRoute,
  AdminPromptTemplatesIndexRoute: AdminPromptTemplatesIndexRoute,
  AdminWorkflowsIndexRoute: AdminWorkflowsIndexRoute,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

interface AuthRouteChildren {
  AuthForgotPasswordRoute: typeof AuthForgotPasswordRoute
  AuthInviteRoute: typeof AuthInviteRoute
  AuthResetPasswordRoute: typeof AuthResetPasswordRoute
  AuthSigninRoute: typeof AuthSigninRoute
  AuthSignupRoute: typeof AuthSignupRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthForgotPasswordRoute: AuthForgotPasswordRoute,
  AuthInviteRoute: AuthInviteRoute,
  AuthResetPasswordRoute: AuthResetPasswordRoute,
  AuthSigninRoute: AuthSigninRoute,
  AuthSignupRoute: AuthSignupRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface OrgSetupRouteChildren {
  OrgSetupSelectOrgRoute: typeof OrgSetupSelectOrgRoute
}

const OrgSetupRouteChildren: OrgSetupRouteChildren = {
  OrgSetupSelectOrgRoute: OrgSetupSelectOrgRoute,
}

const OrgSetupRouteWithChildren = OrgSetupRoute._addFileChildren(
  OrgSetupRouteChildren,
)

interface KbRouteChildren {
  KbOrgSlugSlugRoute: typeof KbOrgSlugSlugRoute
  KbShareTokenRoute: typeof KbShareTokenRoute
}

const KbRouteChildren: KbRouteChildren = {
  KbOrgSlugSlugRoute: KbOrgSlugSlugRoute,
  KbShareTokenRoute: KbShareTokenRoute,
}

const KbRouteWithChildren = KbRoute._addFileChildren(KbRouteChildren)

interface SystemAdminOrgsRouteChildren {
  SystemAdminOrgsOrgIdRoute: typeof SystemAdminOrgsOrgIdRoute
  SystemAdminOrgsIndexRoute: typeof SystemAdminOrgsIndexRoute
}

const SystemAdminOrgsRouteChildren: SystemAdminOrgsRouteChildren = {
  SystemAdminOrgsOrgIdRoute: SystemAdminOrgsOrgIdRoute,
  SystemAdminOrgsIndexRoute: SystemAdminOrgsIndexRoute,
}

const SystemAdminOrgsRouteWithChildren = SystemAdminOrgsRoute._addFileChildren(
  SystemAdminOrgsRouteChildren,
)

interface SystemAdminRouteChildren {
  SystemAdminAdminsRoute: typeof SystemAdminAdminsRoute
  SystemAdminAuditRoute: typeof SystemAdminAuditRoute
  SystemAdminOrgsRoute: typeof SystemAdminOrgsRouteWithChildren
  SystemAdminSettingsRoute: typeof SystemAdminSettingsRoute
  SystemAdminUsersRoute: typeof SystemAdminUsersRoute
  SystemAdminIndexRoute: typeof SystemAdminIndexRoute
}

const SystemAdminRouteChildren: SystemAdminRouteChildren = {
  SystemAdminAdminsRoute: SystemAdminAdminsRoute,
  SystemAdminAuditRoute: SystemAdminAuditRoute,
  SystemAdminOrgsRoute: SystemAdminOrgsRouteWithChildren,
  SystemAdminSettingsRoute: SystemAdminSettingsRoute,
  SystemAdminUsersRoute: SystemAdminUsersRoute,
  SystemAdminIndexRoute: SystemAdminIndexRoute,
}

const SystemAdminRouteWithChildren = SystemAdminRoute._addFileChildren(
  SystemAdminRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  R403Route: R403Route,
  AdminRoute: AdminRouteWithChildren,
  AuthRoute: AuthRouteWithChildren,
  OrgSetupRoute: OrgSetupRouteWithChildren,
  AccountSuspendedRoute: AccountSuspendedRoute,
  AwaitingApprovalRoute: AwaitingApprovalRoute,
  KbRoute: KbRouteWithChildren,
  PendingApprovalRoute: PendingApprovalRoute,
  SystemAdminRoute: SystemAdminRouteWithChildren,
  VerifyEmailRoute: VerifyEmailRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
